import { useNavigate } from '@tanstack/react-router';
import useSearchFilters from './useSearchFilters';
import { isEqual, isEqualWith } from 'lodash';

const useSavedFilters = ({ savedFilters, refetchFilters, mutationKey }) => {
    const navigate = useNavigate();
    const { filters: currentFilters } = useSearchFilters();

    const applySavedFilter = filter => {
        navigate({ search: filter });
    };

    const selectedFilter = savedFilters.filter(({ filter }) =>
        isEqualWith(filter, currentFilters, (a, b) => {
            if (Array.isArray(a) && Array.isArray(b)) {
                return isEqual(a.sort(), b.sort());
            }
        }),
    )?.[0];

    return {
        currentFilters,
        applySavedFilter,
        selectedFilter,
        savedFilters,
        refetchFilters,
        mutationKey,
    };
};

export default useSavedFilters;
